export interface DropdownMenus {
  locations: Array<Dropdown>;
  maritalStatuses: Array<Dropdown>;
  phoneTypes: Array<Dropdown>;
  requestCreditTypes: Array<Dropdown>;
  requestReferalTypes: Array<Dropdown>;
  /**
   * Living situation
   */
  propTypes: Array<Dropdown>;
  employmentStatuses: Array<Dropdown>;
  numVehicleOptions: Array<Dropdown>;
  states: Array<Dropdown>;
  payTypes: Array<Dropdown>;
  payPeriodTypes: Array<Dropdown>;
  checkingOptions: Array<Dropdown>;
  debitOptions: Array<Dropdown>;
  addlIncomeTypes: Array<Dropdown>;
}

export interface Dropdown {
  Disabled: boolean;
  Group: string | null;
  Selected: boolean;
  Text: string;
  Value: string;
}

export enum LivingSituationType {
  rent = 'RENT',
  own = 'OWN',
  parent = 'PARENTS',
}

export enum RequestCreditType {
  individualy = 'IND',
  coApplicant = 'COAPP',
}

export enum EmploymentStatusType {
  unemployed = 'UNEMPLOYED',
  retired = 'RETIRED',
}

export enum PayType {
  hourly = 'HOURLY',
}
